import LocalizedStrings from 'localized-strings';

import { CardFilters } from '../../types';

const locales = new LocalizedStrings({
  en: {
    filters: {
      [CardFilters.OWN]: 'My cards',
      [CardFilters.COMPANY]: 'Company cards',
    },
  },
  fr: {
    filters: {
      [CardFilters.OWN]: 'Mes cartes',
      [CardFilters.COMPANY]: 'Cartes de la société',
    },
  },
} as const);

export default locales;
